import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingIndicatorComponent } from '../../../components/loading-indicator/loading-indicator.component';

@Component({
  selector: 'td-wb-learn-loading',
  templateUrl: 'learn-loading.component.html',
  styleUrls: ['learn-loading.component.scss'],
  imports: [
    LoadingIndicatorComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearnLoadingComponent {
}

